import { render, staticRenderFns } from "./SelectProductsForm.vue?vue&type=template&id=6cd3b21a&scoped=true"
import script from "./SelectProductsForm.vue?vue&type=script&lang=js"
export * from "./SelectProductsForm.vue?vue&type=script&lang=js"
import style0 from "./SelectProductsForm.vue?vue&type=style&index=0&id=6cd3b21a&prod&scoped=true&lang=scss"
import style1 from "./SelectProductsForm.vue?vue&type=style&index=1&id=6cd3b21a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd3b21a",
  null
  
)

export default component.exports